import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ButtonComponent } from 'component/Button';
import 'assets/styles/pages/404.scss';
import 'assets/styles/pages/maintenance.scss';

export const MaintenancePage = () => {
  // const [isChecking, setIsChecking] = useState(false);
  const navigate = useNavigate();

  // const checkMaintenanceStatus = async () => {
  //   setIsChecking(true);
  //   try {
  //     await axios.get('/users/self/');
  //     navigate('/dashboard');
  //   } catch (error) {
  //     if (error.response?.data?.detail?.toLowerCase().includes('maintenance mode')) {
  //       console.log('Maintenance mode is still active');
  //     } else {
  //       navigate('/login');
  //     }
  //   } finally {
  //     setIsChecking(false);
  //   }
  // };

  // const goToLogin = () => {
  //   navigate('/login');
  // };

  return (
    <main className="auth-main error-404">
      <div className="flex-column-group maintenance-page">
        <span>Суперадмін вносить зміни в систему.</span>
        <span>Зачекайте будь-ласка.</span>
        <span className="english-text">Superadmin is making changes to the system.</span>
        <span className="english-text">Please wait.</span>
                {/* <div className="buttons-group">
          <ButtonComponent
            label={isChecking ? "Checking..." : "Try Again"}
            handleButton={checkMaintenanceStatus}
            disabled={isChecking}
          />
          <ButtonComponent
            label="Go to Login"
            handleButton={goToLogin}
            className="warning"
          />
        </div> */}
      </div>
    </main>
  );
};